import React from "react";
import Spinner from "../Spinner";
import styles from "./FullScreenSpinner.module.css";

const FullScreenSpinner = () => (
    <div className={styles.fullScreenSpinner}>
        <Spinner width="28px" height="28px" color="text-mint-500" />
    </div>
);

export default FullScreenSpinner;
